<div class="min-h-screen flex flex-col justify-between">
  <div>
    <lib-context-header></lib-context-header>
    <ems-header></ems-header>
    <ems-banner></ems-banner>
  </div>
  <div class="flex-grow">
    <router-outlet></router-outlet>
  </div>
  <!--  <ems-footer></ems-footer>-->
  <ems-emily-drawer/>
  <ems-file-drawer/>
  @if (auth.isAuthenticated()) {
    <ems-floating-emily-button/>
    <ems-floating-file-button/>

  }
</div>
